jQuery(function($){
    $( document ).ready(function(){
         
      
		$('.testimonial-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: false,
            autoplaySpeed: 3000,
            pauseOnHover: false,
			responsive: [
				{
				  breakpoint: 1025,
				  settings: {
					slidesToShow: 2,
				  },
				},
                {
				  breakpoint: 767,
				  settings: {
					slidesToShow: 1,
				  },
				}
			]
        });

        $('.custom-image-text-slider .slider-wrap').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: false,
            autoplaySpeed: 3000,
            pauseOnHover: false,
        });

        $('.why-us-sec3 .text-with-icons_list').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: false,
            autoplaySpeed: 3000,
            pauseOnHover: false,
            responsive: [
				{
				  breakpoint: 1025,
				  settings: {
					slidesToShow: 3,
				  },
				},
                {
				  breakpoint: 767,
				  settings: {
					slidesToShow: 1,
				  },
				}
			]
        });

      $(".product-accordion-content").hide();
      $(".product-accordion-header").click(function() {
        $(this).next(".product-accordion-content").slideToggle();
        $(".product-accordion-item").not($(this).parent()).removeClass("active");
        $(this).parent().toggleClass("active");
        $(".product-accordion-content").not($(this).next(".product-accordion-content")).slideUp();
      });

      //HOME
      var dotsContainer = $('.cstm-slider-icons .text-with-icons-nav');
      var dots = $('.cstm-slider-icons .text-with-icons__dot');
      var items = $('.cstm-slider-icons .text-with-icons__item');
      dotsContainer.on('click', '.cstm-slider-icons .text-with-icons__dot', function() {
        var index = dots.index($(this));
        setActiveItem(index);
      });
      items.on('click', function() {
        var index = items.index($(this));
        setActiveItem(index);
      });
      // Trigger click event on the first dot to set it as active initially
      setTimeout(function() { 
        items.first().click();
      }, 1000);  
      function setActiveItem(index) {
        dots.removeClass('active');
        items.removeClass('active');
        dots.eq(index).addClass('active');
        items.eq(index).addClass('active');
      }

      //PDP Variation
    
      $('.cstm-variant-topper .variant-swatch__radio').on('click change', function() {

        // Uncheck all radio buttons in the group
        $('.cstm-variant-topper .variant-swatch__radio').prop('checked', false);       
        // Check the clicked radio button
        $(this).prop('checked', true);
        var selectedValue = $(this).val();
        $('.product-form__option-selector.Select-your-Topper-Zones- .select-variant').val(selectedValue).trigger('change');
      });

      // Add smooth scrolling to all anchor links
      $("a[href^='#']").on('click', function(event) {
        event.preventDefault();
        var targetOffset = $($.attr(this, 'href')).offset().top - 60;
        $('html, body').animate({
          scrollTop: targetOffset
        }, 500); // Adjust the animation speed if needed
      });

      //CUSTOM SIZE GUIDE ON CLICK
      $('.product-form__custom-liquid .pbi-size-btn-trigger').on('click', function() {
          $("#measurements-dimensions").addClass('active');
          $("#measurements-dimensions .product-accordion-content").slideToggle();
      });
 //CUSTOM SPECS ON CLICK
      $('.product-form__custom-liquid .pbi-size-btn-trigger2').on('click', function() {
          $("#performance-specs").addClass('active');
          $("#performance-specs .product-accordion-content").slideToggle();
      });

      $('.afterpay-text img').on('click', function() {
          $('afterpay-modal').attr('visible','visible');
      });

      // MOBILE GALLERY
      function initializeSlider() {
        if ($(window).width() < 768) { // You can adjust the width as needed for your mobile breakpoint
          $('.shopify-section--main-product .product__thumbnail-list-inner').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: true,
            infinite: true
          });
        }
      }
      initializeSlider();
      $(window).resize(function(){
        initializeSlider();
      });

      //HOME BANNER TEXT ANIMATION
      var words = ['Life', 'Health', 'Fitness', 'Wellness'];
      var index = 0;
      function changeWord() {
          $('.scrolling-word').fadeOut(function() {
              $(this).text(words[index]).fadeIn();
          });
          index = (index + 1) % words.length;
      }
      // Call the changeWord function every 4000 milliseconds (4 seconds)
      setInterval(changeWord, 2000);    

      // Mobile select variant anchor to size
      $('.pbi-custom-selector-box').on('click', function(){
          // Check if the device width is less than or equal to 767px
          //if($(window).width() <= 767 && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
              // Smooth scroll to the anchor
              $('html, body').animate({
                  scrollTop: $('#zone_charts').offset().top
              }, 1000); // Adjust duration as needed
         // }
      });


    $('.select-size-toggle').click(function() {
      $('.custom-select').slideToggle();
    });

    });
});

window.addEventListener('scroll', function() {
  var articleInfo = document.querySelector('.article__info');
  var rect = articleInfo.getBoundingClientRect();
  
  if (rect.top <= 0) {
    articleInfo.classList.add('sticky');
  } else {
    articleInfo.classList.remove('sticky');
  }
});